import { useState, useEffect, useMemo } from 'react';
import { useSearchHistory } from './useSearchHistory';


export const useSearchSuggestions = () => {
  const { recentSearches, bookmarkedSearches } = useSearchHistory();
  const [suggestions, setSuggestions] = useState({
    keywords: [],
    jobTitles: [],
    locations: []
  });

  useEffect(() => {
    const allSearches = [
      ...(recentSearches?.data || []),
      ...(bookmarkedSearches || [])
    ];

    
    const keywordSet = new Set();
    const jobTitleSet = new Set();
    const locationMap = new Map(); 

    allSearches.forEach(search => {
      if (search.title && typeof search.title === 'string' && search.title.trim()) {
        keywordSet.add(search.title.trim());
      }
      
      if (search.query) {
        if (search.query.keyword && typeof search.query.keyword === 'string' && search.query.keyword.trim()) {
          keywordSet.add(search.query.keyword.trim());
        }
        
        if (search.query.jobTitle && typeof search.query.jobTitle === 'string' && search.query.jobTitle.trim()) {
          jobTitleSet.add(search.query.jobTitle.trim());
        }
        
        if (search.query.targetJobTitle && typeof search.query.targetJobTitle === 'string' && search.query.targetJobTitle.trim()) {
          jobTitleSet.add(search.query.targetJobTitle.trim());
        }
        
        if (search.query.location) {
          if (typeof search.query.location === 'string' && search.query.location.trim()) {
            locationMap.set(search.query.location.trim(), search.query.location.trim());
          } else if (typeof search.query.location === 'object') {
            if (search.query.location.locationId && search.query.location.name) {
              locationMap.set(String(search.query.location.locationId), {
                id: String(search.query.location.locationId),
                name: search.query.location.name.trim()
              });
            } else if (search.query.location.locationId) {
              locationMap.set(String(search.query.location.locationId), {
                id: String(search.query.location.locationId),
                name: `Location ID: ${search.query.location.locationId}`
              });
            } else if (search.query.location.name) {
              locationMap.set(search.query.location.name.trim(), search.query.location.name.trim());
            }
          }
        }
      }
    });

    setSuggestions({
      keywords: Array.from(keywordSet).sort(),
      jobTitles: Array.from(jobTitleSet).sort(),
      locations: Array.from(locationMap.values()).sort((a, b) => {
        const nameA = typeof a === 'object' ? a.name : a;
        const nameB = typeof b === 'object' ? b.name : b;
        return nameA.localeCompare(nameB);
      })
    });
  }, [recentSearches, bookmarkedSearches]);

  return suggestions;
}; 